import { useEffect, useState } from "preact/hooks";
import {
  buyHint,
  canBuyHint,
  guesses,
  hintRevealed,
  puzzle,
  status,
  statusLine,
} from "../game/state";

const FADE_MS = 300;

function GameOver() {
  const won = status.value === "won";
  const used = guesses.value.length + (hintRevealed.value ? 2 : 0);
  const total = puzzle.value.maxGuesses;
  return (
    <div class="hint hint--end">
      <p class="hint__title">{won ? "Solved!" : "Out of guesses"}</p>
      <p class="hint__answer" aria-live="polite">
        {puzzle.value.sentence}
      </p>
      <p class="hint__stats">
        {won ? `Solved in ${used} of ${total}` : `Used ${used} of ${total}`}
        {hintRevealed.value ? " · hint used" : ""}
      </p>
    </div>
  );
}

export function Hint() {
  const playing = status.value === "playing";
  const revealed = hintRevealed.value;
  const canBuy = canBuyHint.value;

  // Keep the button in the DOM during a fade-out so it can transition
  // smoothly, then unmount it. The hint container has a fixed min-height
  // so the board below stays put; once unmounted the remaining-count line
  // re-centers in the reserved space.
  const [buttonMounted, setButtonMounted] = useState(canBuy);
  const fading = buttonMounted && !canBuy;

  useEffect(() => {
    if (canBuy && !buttonMounted) {
      setButtonMounted(true);
      return;
    }
    if (!canBuy && buttonMounted) {
      const t = setTimeout(() => setButtonMounted(false), FADE_MS);
      return () => clearTimeout(t);
    }
    return;
  }, [canBuy, buttonMounted]);

  if (!playing) return <GameOver />;

  return (
    <div class="hint">
      {revealed ? (
        <p class="hint__text" aria-live="polite">
          <span class="hint__label">Hint:</span> {puzzle.value.hint}
        </p>
      ) : buttonMounted ? (
        <button
          type="button"
          class={`hint__button${fading ? " hint__button--fade" : ""}`}
          onClick={() => buyHint()}
          disabled={!canBuy}
          aria-label="Reveal hint (costs 2 guesses)"
        >
          Reveal Hint <span class="hint__cost">(costs 2 guesses)</span>
        </button>
      ) : null}
      <p class="hint__remaining" aria-live="polite">
        {statusLine.value}
      </p>
    </div>
  );
}
